import { ApiError } from '@nyce/admin-kit/api';

/** The server's `{error}` text (k8s_error, too_many_tails, invalid_namespace …) or the thrown message. */
export const errorMessage = (e: unknown): string =>
  e instanceof ApiError ? e.message : (e as Error)?.message || String(e);
